// extracted by mini-css-extract-plugin
export var currencyInput = "_j4-1";
export var currencySymbol = "_j4-0";